// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-rounded{
  border: 2px solid #00aaaf;
  width: 100%;
  border-radius: 5px;
  margin-top: 5px;
  padding: 5px;
  margin-bottom: 5px;
  background-color: #fff;
}
a{
  color: #00aaaf;
}
a:link{
  color: #00aaaf;
}
`, "",{"version":3,"sources":["webpack://./src/components/ForgottenPassword.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB","sourcesContent":[".input-rounded{\n  border: 2px solid #00aaaf;\n  width: 100%;\n  border-radius: 5px;\n  margin-top: 5px;\n  padding: 5px;\n  margin-bottom: 5px;\n  background-color: #fff;\n}\na{\n  color: #00aaaf;\n}\na:link{\n  color: #00aaaf;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
